import { Service } from 'vue-di-container';
import { normalizeRouterRole } from '../../Services/RoleService';
import UserModel from './Model/UserModel';

@Service()
export default class UserRoleService {
    public GetUserRole(user: UserModel): number {
        if (!user) {
            return 0;
        }
        const roleName = normalizeRouterRole(String(user.details.Role || ''));
        switch (roleName) {
            case 'Platform Admin':
                return 1;
            case 'Provider User':
                return 2;
            case 'CITC Admin':
                return 3;
            case 'CITC User':
                return 4;
            case 'Provider Admin':
                return 5;
            case 'Support':
                return 6;
            case 'Service':
                return 7;
            case 'Finance':
                return 8;
            case 'Super Admin':
                return 9;
            case 'Monitor':
                return 10;
            case 'CstTagName':
                return 11;
            case 'API User 330':
                return 14;
            case 'Managing Requests':
                return 15;
            case 'Fraud Management':
                return 16;
            default:
                return 0;
        }
    }
}
